import { __assign, __rest } from "tslib";
import React from 'react';
import { gallectionTypeToResourceType } from '../../types/gallection';
import { Url } from '@wix/da-url';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import OverlayCommentControl from '../../DeviationViews/Helper/OverlayCommentControl';
function gallectionUrl(gallection) {
    // TODO: make using `#folder-comments-${gallection.folderId}` autoscroll to the comments - it won't atm
    return Url.userGalleryLink({
        username: gallection.owner.username,
        gallectionType: gallection.type === 'gallery' ? 'gallery' : 'collection',
        folderId: gallection.folderId,
        folderName: gallection.name,
    });
}
var GallectionCommentControl = function (_a) {
    var gallection = _a.gallection, props = __rest(_a, ["gallection"]);
    return (React.createElement(OverlayCommentControl, __assign({}, props, { showStats: false, href: gallectionUrl(gallection), stat: gallection.commentCount, biData: {
            evid: BiEventType.THUMB_CLICK_COMMENT,
            typeid: gallectionTypeToResourceType(gallection.type),
            creatorid: gallection.owner ? gallection.owner.useridUuid : undefined,
            itemid: gallection.folderId,
        } })));
};
GallectionCommentControl.displayName = 'GallectionCommentControl';
export default GallectionCommentControl;
//# sourceMappingURL=GallectionCommentControl.js.map